var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05859 21.083H17.8975C19.0664 21.083 19.7256 20.4414 19.7256 19.29V10.501L21.0879 11.6436C21.2285 11.7578 21.3691 11.8545 21.5537 11.8545C21.8789 11.8545 22.1338 11.6611 22.1338 11.3447C22.1338 11.1338 22.0635 11.002 21.9053 10.8701L19.7256 9.0332V5.37695C19.7256 5.06055 19.5146 4.8584 19.1982 4.8584H18.3721C18.0645 4.8584 17.8447 5.06055 17.8447 5.37695V7.45117L12.958 3.33789C12.3691 2.83691 11.6572 2.83691 11.0596 3.33789L2.08594 10.8701C1.92773 11.002 1.85742 11.1602 1.85742 11.3271C1.85742 11.5996 2.07715 11.8545 2.4375 11.8545C2.62207 11.8545 2.77148 11.7578 2.90332 11.6436L4.23926 10.5273V19.29C4.23926 20.4414 4.89844 21.083 6.05859 21.083ZM14.4785 13.9023C14.4785 13.5332 14.2412 13.2959 13.8721 13.2959H10.1191C9.75 13.2959 9.50391 13.5332 9.50391 13.9023V20.002H6.28711C5.64551 20.002 5.3291 19.6768 5.3291 19.0264V9.61328L11.6572 4.30469C11.877 4.11133 12.1143 4.09375 12.3516 4.30469L18.6357 9.58691V19.0264C18.6357 19.6768 18.3193 20.002 17.6689 20.002H14.4785V13.9023Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.2d13123c1b897544814edc2f8ac8f95b.svg";
export { ForwardRef as ReactComponent };